/*
 * pickTypes Reducer
 */
import get from 'lodash.get';

import { SCAFFOLD_DATA_LOAD_SUCCEEDED } from '../scaffoldData/constants';
import { RESET_STATE } from '../auth/constants';

const initialState = {};

export default function(state = initialState, action) {
    switch (action.type) {
        case SCAFFOLD_DATA_LOAD_SUCCEEDED:
            return get(action, 'payload.entities.pickTypes', {});
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
